import React from "react";
import { Card } from "semantic-ui-react";
import { Link } from "react-router-dom";
import useTheme from "../../../../hooks/useTheme";
import AppText from "../../../UI/Texts/AppTexts";
import { UserAvatar } from "../../../UI/DisplayImage";
import { RECRUITERS_DASHBOARD_PATH } from "../../../../utils/Constants/Paths";
import i18n, { t } from "i18next";
import { formatRecruiterOnlineStatus } from "../recruiterOnlineStatus";

const RecruiterCard = ({ recruiterData }) => {
  const theme = useTheme();
  const badges = recruiterData?.badges ?? [];
  const onlineStatus = formatRecruiterOnlineStatus({
    isOnline: recruiterData?.isOnline,
    lastOnlineAt: recruiterData?.lastOnlineAt || recruiterData?.updatedAt,
    locale: i18n.language,
    translate: t,
  });
  const directoryTheme = theme.recruiterDirectory;

  return (
    <Link
      to={`${RECRUITERS_DASHBOARD_PATH}/${recruiterData?.slug}`}
      className="recruiter-card-link"
      aria-label={t("recruiters.list.open_profile", {name: recruiterData?.name})}
    >
      <Card
        className="recruiter-card"
        style={{
          "--recruiter-card-padding": directoryTheme.cardPadding,
          "--recruiter-card-avatar": directoryTheme.avatarSize,
          "--recruiter-card-mobile-avatar": directoryTheme.mobileAvatarSize,
          "--recruiter-card-status-dot": directoryTheme.statusDotSize,
          "--recruiter-card-primary": theme.primaryColor,
          "--recruiter-card-online": theme.colors.green,
          "--recruiter-card-surface": theme.colors.white,
          "--recruiter-card-subtle": theme.colors.neutralBg,
          "--recruiter-card-text": theme.colors.dark,
          "--recruiter-card-muted": theme.colors.textSecondary,
          "--recruiter-card-border": theme.colors.lightGrey,
          "--recruiter-card-radius": theme.radius.default,
        }}
      >
        <div className="recruiter-card__main">
          <div className="recruiter-card__avatar-wrap">
            <UserAvatar
              url={recruiterData?.profileImageUrl}
              name={recruiterData?.name}
              style={{height: "100%", width: "100%"}}
              circular
            />
            {recruiterData?.isOnline && <span className="recruiter-card__status-dot" aria-hidden="true" />}
          </div>
          <div className="recruiter-card__content">
            <AppText.SubHeading use="strong" className="recruiter-card__name" fontWeight={600}>
              {recruiterData?.name}
            </AppText.SubHeading>
            {recruiterData?.role && (
              <AppText.BodyText className="recruiter-card__role">
                {recruiterData.role}
              </AppText.BodyText>
            )}
            {!theme.isTenancy && recruiterData?.workplaceName && (
              <AppText.BodyText className="recruiter-card__workplace">
                {recruiterData.workplaceName}
              </AppText.BodyText>
            )}
            {onlineStatus && (
              <AppText.BodyText className={`recruiter-card__online${recruiterData?.isOnline ? " recruiter-card__online--active" : ""}`}>
                {onlineStatus.dateTime ? (
                  <time dateTime={onlineStatus.dateTime} title={onlineStatus.title}>{onlineStatus.label}</time>
                ) : onlineStatus.label}
              </AppText.BodyText>
            )}
          </div>
        </div>
        {badges.length > 0 && (
            <div className="recruiter-card__badges" aria-label={t("recruiters.detail.badges")}>
              {badges.slice(0, 3).map((badge, index) => (
                <div className="recruiter-card__badge" key={`${badge?.id ?? badge}_${index}`} title={badge?.name ?? badge}>
                  {(badge?.imageUrl || badge?.logoUrl) && <img src={badge?.imageUrl || badge?.logoUrl} alt="" />}
                  <span>{badge?.name ?? badge}</span>
                </div>
              ))}
            </div>
        )}
      </Card>
    </Link>
  );
};

export default RecruiterCard;
